import { h, } from "preact";
import { useState, useEffect, useContext } from "preact/hooks";
import { route } from "preact-router";
import { Grid, Typography, Paper, Button, Box, Stack, Table, TableBody, TableRow, TableCell, Tooltip, Stepper, Step, StepLabel } from "@mui/material";

import CircularProgressWithLabel from "../Common/CircularProgressWithLabel";
import DealStatusCard from "../Common/DealStatusCard";

import DealMainInfos from "../Common/DealMainInfos";
import PriceCard from "../Common/PriceCard";
import GroupAddIcon from '@mui/icons-material/GroupAdd';

//import SellerCard from "../Common/SellerCard";
import SellersCard from "../Common/SellersCard";
import BuyersCard from "../Common/BuyersCard";
import AmbassadorProspectsCard from "../Common/AmbassadorProspectsCard";
import AmbassadorDealMeetingsCard from "../Common/AmbassadorDealMeetingsCard";
import { AppContext } from "../../AppContext";

import { SessionContext } from "../../SessionContext";
import { dedupArrayOfObjects } from "../Common/functions";
import ChangeDealName from "../Common/ChangeDealName";
import ButtonWithTooltipAndBadge from "../Common/ButtonWithTooltipAndBadge";
import PublicationCard from "../exports";
import PlaylistAddCircleIcon from '@mui/icons-material/PlaylistAddCircle';

export default function DealDashboardA({ id }) {

	const [state, setState] = useState({});

	const [session, setSession] = useContext(SessionContext);
	useEffect(() => {
		//console.log("session context", session, state)
		if (!session.u) { return }
		let topic = "room:dda-" + id
		if (session.socket && session[topic] === undefined) {

			let channel = session.socket.channel(topic, {})

			channel.on("new_msg",
				msg => {
					console.log("Got message", msg)
					switch (msg.t) {
						case "deal":

							setState((state) => ({
								...state,
								actualDeal: msg.p,
							}));
							break;

						default:

							break;
					}

				})

			channel.join()
				.receive("ok", ({ messages }) => {
					console.log("catching up for ", messages, "room:dda-" + id)
					setSession({ ...session, [topic]: channel })
				})
				.receive("error", ({ reason }) => console.log("failed join", reason))
				.receive("timeout", () => console.log("Networking issue. Still waiting..."))

		}
	}, [session, state]);
	useEffect(() => {
		const requestOptions = {
			method: "GET",
			headers: { "Content-Type": "application/json" },
		};
		fetch("/api/a065204a867b45739e5472ae3eeeaf63/" + id, requestOptions)
			.then((response) => {
				return response.json();
			})
			.then((res) => {
				switch (res.res) {
					case "ok":
						console.log(res.pld)
						setState((state) => ({
							...state,
							actualDeal: res.pld,
						}));

						break;
					case "err":
						break;
					default:
						break;
				}
			});
	}, []);

	if (state.actualDeal === undefined) {
		return;
	}

	useEffect(() => {
		console.log("useEffect", state.actualDeal);
		if (state.actualDeal.duties_u.length > 0) {
			var lbl = (
				<div>
					<Typography variant="h5">Pour avancer dans le processus de vente, il faut</Typography>
					{state.actualDeal.duties_u.map((ln) => {
						return <Typography variant="body1">{ln.label}</Typography>;
					})}


					{/* {!state.actualDeal.mandate && <Typography variant="body1">- Que les vendeurs signent le mandat de vente</Typography>} */}
				</div>
			);
			var actions = dedupArrayOfObjects(state.actualDeal.duties_u).reduce((acc, action) => {
				//console.log(u.action);
				if (action !== null) {
					return acc.concat(<Button
						variant="contained"
						onClick={() => {
							window.location.href = action.u;
						}}
					>
						{action.l}
					</Button>)
				}

			}, [])
			var icon = <CircularProgressWithLabel mode="count" num={state.actualDeal.mandate + state.actualDeal.psfp} tot={2} />;
			app.refHeader.current.handleChangeState({
				guidelines: {
					message: lbl,
					actions: [actions],
					icon: <PlaylistAddCircleIcon
					//color="primary"
					/>,
					severity: "warning"
				}
			})
			return;
		}

	}, [state]);

	const steps = ["En constitution", "En vente", "Offre", "Promesse", "Acte authentique"];

	const app = useContext(AppContext);

	return (

		<div style="">
			<Grid container spacing={2}>
				<Grid item xs={12}>
					<Paper style="padding: 5px">
						<Grid container alignItems="center">
							<Grid item xs={12} md={8}>
								<Stepper
									activeStep={state.actualDeal.ias ? 5 : state.actualDeal.iss ? 4 : state.actualDeal.off ? 3 : state.actualDeal.bid ? 2 : state.actualDeal.pub ? 1 : 0}
									alternativeLabel
								>
									{steps.map((label) => (
										<Step key={label}>
											<StepLabel>{label}</StepLabel>
										</Step>
									))}
								</Stepper>
							</Grid>
							<Grid item xs={12} md={4}>
								{!state.actualDeal.closed_deal && <Box display="flex" alignItems="center" justifyContent="flex-end" p={1} m={1}>
									<Box>
										<Tooltip title="..." placement="bottom" arrow style="margin-left: 10px;">
											<Button
												variant="outlined"
												onClick={
													() => {
														app.refPopUp.current.handleChangeState(
															{ opened: true, type: "027", params: { uid: id, name: state.name } }
														)

													}}
											>
												Quitter ce dossier de vente
											</Button>
										</Tooltip>
									</Box>
								</Box>}
							</Grid>
						</Grid>
					</Paper>
				</Grid>
				<Grid item xs={12}>
					<Grid container spacing={2}>
						<Grid item xs={12} md={4}>
							<Stack spacing={1}>
								<ChangeDealName actualDeal={state.actualDeal} />
								<PriceCard actualDeal={state.actualDeal} mode="A" />
								<DealMainInfos state={state} uid={id} mode="A" />
							</Stack>
						</Grid>
						<Grid item xs={12} md={4}>
							<Stack spacing={2}>


								<Stack spacing={1}>
									{/* {!state.actualDeal.mandate && <Box p={1}>
											<ButtonWithTooltipAndBadge
												tooltip="Gérer les vendeurs"
												icon={<GroupAddIcon />}
												onclick_cb={() => {
													window.location.href = "/sellers/" + id;
												}}
												badge={state.actualDeal.sellers.length === 0} />

										</Box>} */}
									<SellersCard actualDeal={state.actualDeal}
										mode="AM"
										btn={!state.actualDeal.mandate &&
											<ButtonWithTooltipAndBadge
												tooltip="Gérer les vendeurs"
												icon={<GroupAddIcon />}
												onclick_cb={() => {
													window.location.href = "/sellers/" + id;
												}}
												badge={state.actualDeal.sellers.length === 0} />}
									/>

								</Stack>
								{state.actualDeal.oabs && (
									<BuyersCard actualDeal={state.actualDeal} mode="AM" />
								)}
								{!state.actualDeal.oabs && (
									<AmbassadorProspectsCard actualDeal={state.actualDeal} id={id} />
								)}
								<AmbassadorDealMeetingsCard actualDeal={state.actualDeal} />
							</Stack>
						</Grid>
						<Grid item xs={12} md={4}>
							<Stack spacing={1}>
								<DealStatusCard state={state} uid={id} mode="A" />
								<PublicationCard uid={id} />

							</Stack>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</div>
	);
}
